export const right = {
  id: '5-right',
  name: 'Kitchen Corner',
  levels: [
    {
      tileSize: 256,
      size: 256,
      fallbackOnly: true,
    },
    {
      tileSize: 512,
      size: 512,
    },
    {
      tileSize: 512,
      size: 1024,
    },
    {
      tileSize: 512,
      size: 2048,
    },
  ],
  faceSize: 2048,
  initialViewParameters: {
    yaw: 1.0297929172360494,
    pitch: 0.5967537926038808,
    fov: 1.4254872060750312,
  },
  linkHotspots: [
    {
      yaw: 3.1127797887121265,
      pitch: 0.5530499747859654,
      rotation: 4.71238898038469,
      target: '3-range',
    },
    {
      yaw: 3.1178629952955585,
      pitch: 0.05361514900166675,
      rotation: 3.9269908169872414,
      target: '0-countertop',
    },
    {
      yaw: -1.5699387643857214,
      pitch: 0.536458072271456,
      rotation: 1.5707963267948966,
      target: '4-left',
    },
    {
      yaw: -2.329734251068224,
      pitch: 0.07197939033376599,
      rotation: 9.42477796076938,
      target: '2-island',
    },
    {
      yaw: -1.9484867535410917,
      pitch: -0.010687982665281481,
      rotation: 3.141592653589793,
      target: '1-dining',
    },
  ],
  infoHotspots: [
    {
      yaw: 1.9739274760992975,
      pitch: 0.3741277051097569,
      title: 'Digital Kitchen Timer',
      text: `
<ul>
<li><span class='b'> #100479</span></li>
<li> <span class='b'>USD</span> $25 | <span class='b'>CAD</span> $32</li>
<li> 3-year guarantee</li>
<li> Wipe clean</li>
<li> 2½" x 3½" (6 cm x 9 cm)</li>
<li> Includes Second, Minute, Hour, Clear, Go-Stop, and Clock buttons, a magnet, a clip, and one CR2032 (3v) lithium battery.</li>
<li> Run four timers at the same time.</li>
<li> Switch between timers so you can easily track progress, plus each timer has a different number of beeps when time is up.</li>
<li> Can be set to either 12- or 24-hour setting. Just press the Clock button to see what time it is.</li>
<li> Place it on your refrigerator or any magnetized surface.</li>
<li> Wear it while on the go or flip open to stand on the counter for easy viewing.</li>

</ul>
        `,
      images: [
        { id: `exgdbsbvcn`, key: `nc1-gs3-5` },
        { id: `js0rkcfvfl`, key: `nc1-gs3-6` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569999690" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: 1.1866944362369534,
      pitch: 0.2879972136887634,
      title: 'Carving Set',
      text: `
<ul>
<li><span class='b'> #100476</span></li>
<li> <span class='b'>USD</span> $175 | <span class='b'>CAD</span> $225</li>
<li> Knife & Fork: Lifetime guarantee <br/> Storage Box: 3-year guarantee</li>
<li> Knife & Fork: Hand wash<br/> Storage Box: Wipe clean</li>
<li> Knife: 8" (20-cm) blade. Fork: 4½" (12-cm) tines.</li>
<li> German steel, full-tang carving set includes a knife, fork, and wood storage case with magnetic closure.</li>
<li> Carve precise slices for impressive results every time.</li>
<li> Our carving knife has a long, narrow blade with a pointed tip and the fork has two sharp, long prongs to hold the meat firmly in place while slicing to help keep your hands safe.</li>
<li> The bolsters evenly distribute weight and keep the knives balanced, and ergonomic, durable pakkawood handles provide comfortable control.</li>
<li> <span class='b'>Great for:</span> roasts, holiday hams, and Thanksgiving turkeys.</li>
<li><span class="b teal-text">Get it at a discount or for free when you host a party. Ask your consultant for details.</span></li>
</ul>
        `,
      images: [
        {
          id: `up7plrb8ht`,
          key: `nc1-gs2-20`,
        },
        { id: `avb5sumalj`, key: `nc1-gs2-21` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569999531" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: 1.789718246715852,
      pitch: 0.3085611373127435,
      title: 'Sauce Whisk',
      text: `
<ul>
<li><span class='b'> #100483</span></li>
<li> <span class='b'>USD</span> $18 | <span class='b'>CAD</span> $20</li>
<li> 3-year guarantee</li>
<li> Dishwasher-safe | Heat-safe to 450°F (230°C)</li>
<li> 11" (28 cm)</li>
<li> Specially designed to help you make silky smooth sauces, roux, and more. </li>
<li> Sturdy silicone coils won’t scratch your cookware.</li>
<li> Angled head and stainless handle comfortably reach into the edges for more thorough blending and less scorching.</li>
<li> <span class='b'>Great for:</span> sauces, roux, eggs, dressings, and marinades.</li>

</ul>
        `,
      images: [
        { id: `dwgqm6hkwo`, key: `nc1-gs2-12` },
        { id: `hdmelxj747`, key: `nc1-gs2-13` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/570000098" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: 1.5986022063654586,
      pitch: 0.31537628610997004,
      title: 'Baster',
      text: `
<ul>
<li><span class='b'> #100480</span></li>
<li> <span class='b'>USD</span> $14 | <span class='b'>CAD</span> $19</li>
<li> 3-year guarantee</li>
<li> Dishwasher-safe | Heat-resistant to 245°F (118°C)</li>
<li> 12" (30 cm)</li>
<li> Includes a cleaning brush (hand-wash only)</li>
<li> Our durable baster will help you turn out flavorful meals all year long. Basting creates that golden-brown, picture-perfect turkey that’s the showcase of Thanksgiving dinner.</li>
<li> Good suction, handy measurement markings, and a flat area on the bulb so it won’t roll off the counter when you set it down.</li>
<li> Remove a layer of fat from simmering stock, or drain excess fat from a skillet of ground meat.</li>
<li> <span class='b'>Great for:</span> turkey, pork roast, chicken, pan-seared scallops, pork chops, and fish. </li>

</ul>
        `,
      images: [
        { id: `gziwatrd7w`, key: `nc1-gs2-14` },
        { id: `i1xlpvqihd`, key: `nc1-gs2-15` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569993939" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: 0.30110269394183575,
      pitch: 0.29956155728185685,
      title: 'Meal Mixes',
      text: `
<ul>
<br/>
<span class="title">Chili Mix</span>
<li><span class='b'> #100524</span></li>
<li> <span class='b'>USD</span> $11 | <span class='b'>CAD</span> $15</li>
<li> Gluten-Free, Kosher</li>
<li> Set of 3 packets, 1.4 oz. (39 g) each </li>
<li> A custom blend of chili powder, cumin, oregano, garlic, and other spices. A bold flavor that’s not spicy, so the whole family can enjoy.</li>
<li> Simply stir into your favorite chili recipe for instant flavor. </li>
<li> Cook on the stovetop or in the slow cooker for a chili or use it to inspire a new dish.</li>
<li> <span class='b'>Great for:</span> meat, meat alternatives, veggies, tacos, nachos, seven-layer dip, and more.</li>
<br/>
<span class="title">Tuscan-Style Herb Chicken Mix</span>
<li> <span class="b">#100525</span></li>
<li> <span class="b">USD</span> $11 | <span class="b">CAD</span> $15</li>
<li> Gluten-Free, Kosher</li>
<li> Set of 3 packets, 1.4 oz. (39 g) each</li>
<li> A perfect mix of garlic, rosemary, basil, parsley, and more.</li>
<li> Get the flavors of Tuscany right in your own kitchen!</li>
<li> <span class='b'>Great for:</span> roasts, chicken noodle soup, chicken & dumplings, stews, and sauces to get the bright flavors of the Italian countryside. </li>

    </ul>    `,
      images: [
        { id: `wofs7ochha`, key: `nc1-gs1-22` },
        { id: `r2m8aazzhr`, key: `nc1-gs1-23` },
        { id: `h12uvbtts0`, key: `nc1-gs1-24` },
        { id: `n8rkefwqsm`, key: `nc1-gs1-25` },
        { id: `rynn0zwqpx`, key: `nc1-gs1-26` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/570018208" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
        `<iframe src="https://player.vimeo.com/video/570018217" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
  ],
};
